import { useState, useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { Table, TableHead, TableBody, TableCell, TableRow, Typography, TablePagination } from '@mui/material';

// constants
import { colors } from '../../theme';
import { MOMENT_DATE_DISPLAY_FORMAT, MOMENT_TIME_FORMAT, MOMENT_TIME_DISPLAY_FORMAT } from '../../constants/date_format';

const RoomConflictsGrid = (props: any) => {
    const { data, resetPage, filterObject, isFilteredGrid } = props;

    const [page, setPage] = useState(0);
    const [rowData, setRowData] = useState([...data]);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    // TODO: add pagination
    const handleChangePage = (event: any, newPage: any) => {
        setPage(newPage);
    };

    const getGridHeight = () => {
        const screenHeight = window.innerHeight;
        const navHeight = 52;

        const pageHeight = screenHeight - (navHeight + 60);

        const numRows = Math.trunc(pageHeight / 46);

        // const gridHeight = 45 * numRows + 35;

        setRowsPerPage(numRows - 1);
    };

    useEffect(() => {
        getGridHeight();
    }, []);

    useEffect(() => {
        let totalConflicts = 0;
        for (const row of data) {
            totalConflicts += row.conflicts.length;
        }
        setRowData(data);
        setTotalPages(totalConflicts);

        if (resetPage) setPage(0);
    }, [data]);

    const getGridData = (data: any) => {
        let conflicts = [...data];
        const { subject, date, timeIn, timeOut } = filterObject;
        if (isFilteredGrid) {
            if (subject) conflicts = conflicts.filter((c) => c.subject?.toLowerCase().includes(subject.toLowerCase()));
            if (date) conflicts = conflicts.filter((c) => moment(c.date).isSame(moment(date)));
            if (timeIn) {
                conflicts = conflicts.filter((c) => moment(c.timeIn, MOMENT_TIME_FORMAT).isSameOrAfter(moment(timeIn, MOMENT_TIME_FORMAT)));
            }
            if (timeOut) {
                conflicts = conflicts.filter((c) => moment(c.timeOut, MOMENT_TIME_FORMAT).isSameOrBefore(moment(timeOut, MOMENT_TIME_FORMAT)));
            }
        }
        return conflicts;
    };

    const isEmpty = rowData?.every((room) => getGridData(room.conflicts)?.length === 0);

    return (
        <>
            <StyledTable stickyHeader>
                <TableHead>
                    <StyledTableRow>
                        <TableCell sx={{ width: '10%' }}>Conflict Date</TableCell>
                        <TableCell sx={{ width: '8%' }}>Subject</TableCell>
                        <TableCell sx={{ width: '8%' }}>Course #</TableCell>
                        <TableCell sx={{ width: '8%' }}>CRN</TableCell>
                        <TableCell sx={{ width: '40%' }}>Instructor(s)</TableCell>
                        <TableCell sx={{ width: '10%' }}>Time In</TableCell>
                        <TableCell sx={{ width: '10%' }}>Time Out</TableCell>
                    </StyledTableRow>
                </TableHead>
                {rowData &&
                    rowData?.length > 0 &&
                    rowData.map((room: any, i: any) => {
                        if (room.conflicts) {
                            return (
                                <>
                                    {getGridData(room.conflicts)?.length > 0 && (
                                        <>
                                            <RoomCell key={i}>
                                                <TableCell>Room: {room.roomNumber}</TableCell>
                                                <TableCell />
                                                <TableCell />
                                                <TableCell />
                                                <TableCell />
                                                <TableCell />
                                                <TableCell />
                                            </RoomCell>
                                            <TableBody sx={{ height: 'max-content' }}>
                                                {getGridData(room.conflicts).map((conflict: any) => {
                                                    return (
                                                        <StyledTableRow>
                                                            <TableCell sx={{ width: '10%' }}> {moment(conflict.date).format(MOMENT_DATE_DISPLAY_FORMAT)}</TableCell>
                                                            <TableCell sx={{ width: '8%' }}> {conflict.subject}</TableCell>
                                                            <TableCell sx={{ width: '8%' }}> {conflict.courseNumber}</TableCell>
                                                            <TableCell sx={{ width: '8%' }}> {conflict.crn}</TableCell>
                                                            <TableCell sx={{ width: '40%' }}> {conflict.instructors.map((instructor) => instructor + ', ')}</TableCell>
                                                            <TableCell sx={{ width: '10%' }}> {moment(conflict.timeIn, MOMENT_TIME_FORMAT).format(MOMENT_TIME_DISPLAY_FORMAT)}</TableCell>
                                                            <TableCell sx={{ width: '10%' }}> {moment(conflict.timeOut, MOMENT_TIME_FORMAT).format(MOMENT_TIME_DISPLAY_FORMAT)}</TableCell>
                                                        </StyledTableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </>
                                    )}
                                </>
                            );
                        }
                    })}
                {isEmpty && (
                    <TableCell colSpan={7} sx={{ textAlign: 'center', borderBottom: `1px solid ${colors.grey.light}` }}>
                        No data found.
                    </TableCell>
                )}
            </StyledTable>
            {/* <StyledTableFooter>
                <TablePagination count={totalPages} onPageChange={handleChangePage} rowsPerPage={rowsPerPage} rowsPerPageOptions={[-1]} page={page} />
            </StyledTableFooter> */}
        </>
    );
};

export default RoomConflictsGrid;

const StyledTable = styled(Table)`
    && {
        background-color: ${colors.white};
        padding: 2px 0px;
        margin-top: 10px;
        border-radius: 5px;
    }
`;

const StyledTableRow = styled(TableRow)`
    && {
        th {
            padding: 5px 15px;
            border-color: ${colors.grey.light};
        }

        td {
            padding: 10px 17px;
            border-color: ${colors.grey.light};
        }

        &:hover {
            background-color: ${colors.blue.light};
        }
    }
`;

const RoomCell = styled(TableRow)`
    && {
        td {
            background-color: ${colors.blue.light};
            border: none;
            padding: 5px 20px;
            font-weight: 700;
            /* color: ${colors.grey.dark}; */
            color: ${colors.blue.main};
            font-size: 14px;
        }
    }
`;

const StyledTableFooter = styled(TableRow)`
    && {
        display: flex;
        justify-content: flex-end;

        .MuiTablePagination-toolbar {
            min-height: 20px;
            text-align: right;
        }

        td {
            border-bottom: none;
            text-align: right;
        }
    }
`;
